import { createContext, useContext } from "react";
import type { StateCardVariant } from "./types";

interface StateCardContextValue {
  variant: StateCardVariant;
}

export const StateCardContext = createContext<StateCardContextValue | null>(
  null,
);

export function useStateCardContext() {
  const ctx = useContext(StateCardContext);
  if (!ctx) {
    throw new Error("StateCard sub-components must be used within <StateCard>");
  }
  return ctx;
}
